import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {UserRegistrationRedirectService} from '@app/services/user-registration/user-registration-redirect.service';
import {UserRegistrationConfigService} from '@app/services/user-registration/user-registration-config.service';
import {DcpUserService} from '@app/services/user/dcp-user.service';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {DcpCustomerRegistrationDecoratorService} from '@app/services/dcp-customer-registration-decorator.service';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationGuard  {

  constructor(
    private router: Router,
    private userRegistrationConfigService: UserRegistrationConfigService,
    private userRegistrationRedirectService: UserRegistrationRedirectService,
    private userService: DcpUserService,
    private transactionTypeService: TransactionTypeService,
    private authService: DcpAuthService,
    private customerRegistrationService: DcpCustomerRegistrationDecoratorService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return combineLatest([
      this.customerRegistrationService.getCurrentUser(),
      this.transactionTypeService.getTransactionTypeConfiguration(route.queryParamMap.get('action') || TransactionTypeCode.ORDER_NEW),
      this.authService.isUserLoggedIn(),
    ]).pipe(
      take(1),
      switchMap(([user, transactionType, isLoggedIn]) => this.userService.isCustomerKnown(user).pipe(map((isCustomerKnown) => {
        if (isLoggedIn && transactionType.isFullRegistrationRequired && !isCustomerKnown) {
          this.userRegistrationConfigService.fetchConfigFromUrl(route);
          this.userRegistrationRedirectService.saveCurrentNavigationUrl(state);
          return this.router.parseUrl('/selectionType');
        }
        return true;
      }))),
    );
  }
}
